import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getAnalytics } from 'firebase/analytics';

// Production GA: G-DF0F7G97ZW | Staging/Localhost GA: G-Z22BRVPJJ8
const isProduction = window.location.hostname === 'streakforcash.com'
  || window.location.hostname === 'www.streakforcash.com';

const firebaseConfig = {
  apiKey: 'AIzaSyBqmLrCXdllbrAgq-2aJzxh9BYYNq5XBfY',
  authDomain: 'streak-for-cash-8e3ba.firebaseapp.com',
  projectId: 'streak-for-cash-8e3ba',
  storageBucket: 'streak-for-cash-8e3ba.firebasestorage.app',
  messagingSenderId: '159943614538',
  appId: '1:159943614538:web:5a588245a99dfba3de46b3',
  measurementId: isProduction ? 'G-DF0F7G97ZW' : 'G-Z22BRVPJJ8',
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);
export const analytics = getAnalytics(app);

// Disable reCAPTCHA verification for localhost development
// This is the official Firebase recommendation for local dev
// In production (Firebase Hosting), reCAPTCHA works normally
if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
  auth.settings.appVerificationDisabledForTesting = true;
}

export default app;
